// extracted by mini-css-extract-plugin
module.exports = {"cardImg":"CardLocked_cardImg__2RCtq","cardName":"CardLocked_cardName__2MhWq","cardPrice":"CardLocked_cardPrice__3R2s2","cardPriceLocked":"CardLocked_cardPriceLocked__B-ybf"};